<template lang="pug">
#filtros
    el-card.mb-3(:body-style='{ padding: "1px" }')
        el-collapse(style='border: none', v-model='filtros.exibirFiltros')
            el-collapse-item(name='filtros')
                span.filtros(slot='title')
                    i.mdi.mdi-filter-variant.filter-icon
                    | Filtros
                el-form.fields(label-position='top')
                    el-form-item.pesquisa
                        el-input(
                            v-model='filtros.pesquisa',
                            placeholder='Busque pelo número da operação'
                        )

                    el-form-item.dataContrato
                        label Data do Contrato
                        .date
                            el-date-picker.w-100(
                                v-model='dataContrato',
                                type='daterange',
                                placeholder='Selecione',
                                range-separator='-',
                                style='width: 100%',
                                format='dd/MM/yyyy',
                                start-placeholder='Data de início',
                                end-placeholder='Data do fim'
                            )

                    el-form-item.vigenciaContrato
                        label Vencimento do Contrato
                        .date
                            el-date-picker(
                                v-model='dataVencimento',
                                type='daterange',
                                placeholder='Selecione',
                                style='width: 100%',
                                range-separator='-',
                                format='dd/MM/yyyy',
                                start-placeholder='Data de início',
                                end-placeholder='Data do fim'
                            )

                    el-form-item.culturas
                        label Culturas
                        el-select(
                            placeholder='Selecione a Cultura',
                            style='width: 100%',
                            v-model='culturaSelecionada',
                            clearable
                        )
                            el-option(
                                v-for='item in culturas',
                                :key='item.id',
                                :label='item.nome',
                                :value='item.id'
                            )

                    el-form-item.actions
                        BaseButton(
                            icon='el-icon-delete',
                            @click='limparFiltros'
                        ) Limpar
                        BaseButton(
                            type='primary',
                            icon='el-icon-receiving',
                            @click='filtrar'
                        ) Filtrar

    .lista-operacao__filtros
        span.lista-operacao__filtros__titulo Selecione uma situação para visualizar as operações
            .filtro-status
                BaseButton(
                    round,
                    @click='definirStatus("EM_PROCESSAMENTO")',
                    :type='filtros.status.includes("EM_PROCESSAMENTO") ? "primary" : ""'
                ) Em processamento
                BaseButton(
                    round,
                    @click='definirStatus("PROCESSADO")',
                    :type='filtros.status.includes("PROCESSADO") ? "primary" : ""'
                ) Processado
                BaseButton(
                    round,
                    @click='definirStatus("APROVADO")',
                    :type='filtros.status.includes("APROVADO") ? "primary" : ""'
                ) Aprovado
                BaseButton(
                    round,
                    @click='definirStatus("REPROVADO")',
                    :type='filtros.status.includes("REPROVADO") ? "primary" : ""'
                ) Reprovado
                el-button(
                    round,
                    @click='definirStatus("VENCIDO")',
                    :type='filtros.status.includes("VENCIDO") ? "primary" : ""'
                ) Vencido
</template>

<script>
import OperacaoCdaWaService from '@/services/OperacaoCdaWaService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'Filtros',

    components: {
        BaseButton
    },

    data() {
        return {
            perfilAnalista: null,
            culturas: [],
            exibirFiltros: 'filtros',
            dataContrato: null,
            dataVencimento: null,
            culturaSelecionada: null,
            filtros: {
                dataContratoInicio: null,
                dataContratoFim: null,
                dataVencimentoInicio: null,
                dataVencimentoFim: null,
                pesquisa: null,
                idsCulturas: null,
                possuiAlerta: false,
                status: []
            }
        };
    },

    created() {
        this.limparFiltros();
        this.buscarCulturas();
    },

    methods: {
        limparFiltros() {
            this.dataContrato = null;
            this.dataVencimento = null;
            this.culturaSelecionada = null;

            this.filtros = {
                dataContratoInicio: null,
                dataContratoFim: null,
                dataVencimentoInicio: null,
                dataVencimentoFim: null,
                pesquisa: null,
                idsCulturas: null,
                possuiAlerta: false,
                status: []
            };

            this.filtrar();
        },

        validarDatas() {
            if (this.dataContrato !== null) {
                this.filtros.dataContratoInicio =
                    this.dataContrato[0].toLocaleDateString('pt-BR');
                this.filtros.dataContratoFim =
                    this.dataContrato[1].toLocaleDateString('pt-BR');
            } else {
                this.filtros.dataContratoInicio = null;
                this.filtros.dataContratoFim = null;
            }

            if (this.dataVencimento !== null) {
                this.filtros.dataVencimentoInicio =
                    this.dataVencimento[0].toLocaleDateString('pt-BR');
                this.filtros.dataVencimentoFim =
                    this.dataVencimento[1].toLocaleDateString('pt-BR');
            } else {
                this.filtros.dataVencimentoInicio = null;
                this.filtros.dataVencimentoFim = null;
            }
        },

        async buscarCulturas() {
            try {
                const { data } = await OperacaoCdaWaService.buscarCulturas();
                this.culturas = data;
            } catch {
                this.$notify.error({
                    message: 'Não foi possível buscar as culturas.'
                });
            }
        },

        definirStatus(status) {
            this.filtros.status =
                this.filtros.status[0] !== status ? [status] : [];

            this.filtrar();
        },

        filtrar() {
            this.validarDatas();

            this.filtros.idsCulturas =
                this.culturaSelecionada === null ||
                this.culturaSelecionada === ''
                    ? null
                    : [this.culturaSelecionada];

            this.$emit('filtrar', this.filtros);
        }
    }
};
</script>

<style lang="scss" scoped>
#filtros {
    .fields {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-areas:
            'pesquisa pesquisa pesquisa'
            'dataContrato vigenciaContrato culturas'
            'vazio vazio actions';

        column-gap: 15px;
        padding: 0 20px;

        .pesquisa {
            grid-area: pesquisa;
        }

        .dataContrato {
            grid-area: dataContrato;
        }

        .vigenciaContrato {
            grid-area: vigenciaContrato;
        }

        .culturas {
            grid-area: culturas;
        }

        .actions {
            grid-area: actions;
            display: flex;
            justify-content: flex-end;
            margin-top: 10px;
        }
    }

    .filtros {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 15px;
    }

    .el-collapse-item__content {
        padding-bottom: 10px;
    }

    .container-filtro {
        display: flex;
        justify-content: space-between;
    }
}
</style>
